import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()(theme => ({
  cropContainer: {
    position: 'relative',
    width: '100%',
    height: 220,
    background: '#333',
    [theme.breakpoints.up('sm')]: {
      height: 380,
    },

    '&.tip-hidden .reactEasyCrop_CropArea:after': {
      opacity: 0,
      transitionDuration: '100ms',
    },

    '& .reactEasyCrop_CropArea:after': {
      content: '"Drag to reposition"',
      opacity: 1,
      whiteSpace: 'nowrap',
      userSelect: 'none',
      pointerEvents: 'none',
      position: 'absolute',
      padding: theme.spacing(1, 2),
      paddingTop: '11px',
      paddingLeft: theme.spacing(5),
      backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' viewBox=\'0 0 24 24\' width=\'24\' height=\'24\'%3E%3Cpath fill=\'%23fff\' d=\'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z\' /%3E%3C/svg%3E%0A")',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '10px center',
      top: theme.spacing(3),
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(0, 0, 0, 0.6)',
      color: '#fff',
      borderRadius: 4,
      zoom: 0.7,
      [theme.breakpoints.up('sm')]: {
        top: theme.spacing(2),
        zoom: 1,
      }
    }
  },
  controlWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  control: {
    padding: theme.spacing(1),
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '70%',
      padding: theme.spacing(4),
    }
  },
  iconLeft: {
    opacity: 0.4,
    paddingRight: theme.spacing(2),
  },
  iconRight: {
    opacity: 0.4,
    paddingLeft: theme.spacing(2),
  },
}));
